<template>
<el-dialog :visible.sync="showPushDialog" :close-on-click-modal="false" :before-close="handleClose" width="560px"
  title="推送提醒">
  <div>
    <el-form ref="rightsForm" :model="pushReminderForm" :rules="formRules" label-width="90px">
      <el-form-item label="推送文案：" prop="name">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 5}" size="medium" v-model.trim="pushReminderForm.pushMsg" maxlength="100" show-word-limit></el-input>
      </el-form-item>
    </el-form>
  </div>
  <div style="margin-top:20px;text-align:center">
    <el-button size="small" @click="handleClose">取 消</el-button>
    <el-button size="small" type="primary" @click="handlePush">推 送</el-button>
  </div>
</el-dialog>
</template>
<script>
import { apiTaskPushMsg } from "@/views/treatment/api/crossApi";
export default {
  props: {
    showPushDialog: {
      type: Boolean,
      default: false
    },
    pushRemindItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pushReminderForm: {
        pushMsg: ''
      },
      formRules:{},
      defaultPushText: {
        1: '如果您已按照医嘱完成了相应的治疗康复，请在“健康打卡”页进行打卡操作，以便医生及时获知您的治疗康复进度。如果您还未完成相应的治疗康复打卡要求，请及时安排和完成打卡。',
        2: '如果您已按照医嘱完成了相应的治疗康复，请在“健康打卡”页进行打卡操作，以便医生及时获知您的治疗康复进度。如果您还未完成相应的治疗康复打卡要求，请及时安排和完成打卡。',
        5: '本次复诊需要做哪些项目，快来查看一下吧~如您已复诊，请上传本次复诊病历资料，以便医生及时获知您的治疗康复进度。',
        9: '如果您已按照医嘱完成了相应的治疗康复，请在“健康打卡”页进行打卡操作，以便医生及时获知您的治疗康复进度。如果您还未完成相应的治疗康复打卡要求，请及时安排和完成打卡。',
        8: '为了提高和维护健康，请您及时查看宣教文章~', // 健康宣教
        10: '本次重点指标需要做哪些任务，快来查看一下吧~如您已完成，请忽略。' // 重点指标
      }
    }
  },
  async created() {
    this.pushReminderForm.pushMsg = this.defaultPushText[this.pushRemindItem.source]
  },
  mounted() {},
  methods: {
    handlePush() {
      // 保存时转换
      if (this.pushReminderForm.pushMsg.match(/^[ ]*$/)) {
        this.pushReminderForm.pushMsg = this.pushReminderForm.pushMsg.replace(/\s+/g, '')
        return
      }
      this.pushReminderForm.pushMsg = this.$setEditorText(this.pushReminderForm.pushMsg)

      // this.patientId, this.pushRemindItem.source
      apiTaskPushMsg({
        patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
        source: this.pushRemindItem.source,
        text: this.pushReminderForm.pushMsg
        // wholeCourseId: this.$route.path == '/case' ? this.$store.state.serviceItem.wholeCourseId : null
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "推送提醒成功",
            type: "success"
          });
          this.$emit('update:showPushDialog', false)
          // this.$emit("getPatientRightData", 6);
        } else {
          this.$message.error(res.message);
          this.$emit('update:showPushDialog', false)
        }
      }).catch(err => {
        this.$emit('update:showPushDialog', false)
      });
    },
    handleClose() {
      this.$emit('update:showPushDialog', false)
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-input__count {
  height: 20px;
  line-height: 20px;
}
</style>